<form [formGroup]="form">
    <mat-form-field appearance="outline"  >
        <mat-label>{{ label | translate }}</mat-label>
        <mat-select disableOptionCentering="true" formControlName="Id">
            <!-- <mat-option value="" selected> {{'Common.Choose'|translate}} </mat-option> -->
            <mat-option class="theme-select" *ngFor="let item of dataSource" [value]="item.Id" (click)="onClick()">
                [{{ item.NameAr }}] - {{ item.NameEn }}
            </mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('Id')?.errors?.['required']">
            {{ 'Common.RequiredField' | translate }}
        </mat-error>
    </mat-form-field>
</form>